import DFSettings from "@/views/deltaforce/settings/DFSettings.vue";
import WeaponBuilds from "@/views/deltaforce/weaponbuilds/WeaponBuilds.vue";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/df/builds",
    name: "DF Builds",
    component: WeaponBuilds,
  },
  {
    path: "/df/settings",
    name: "DF Settings",
    component: DFSettings,
  },
  {
    path: "/music/queue",
    name: "Musik Queue",
    component: () => import("../views/music/MusicQueue.vue"),
  },
  {
    path: "/donate",
    name: "Donate",
    component: () => import("../views/DonateView.vue"),
  },
  {
    path: "*",
    name: "*",
    component: HomeView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
